"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var client_1 = require("@apollo/client");
var initPayment_1 = require("../graphql/mutations/initPayment");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var errorHandler_1 = require("../../../common/service/errorHandler");
var usePriceFormatter_1 = require("../../../../../../common/react/usePriceFormatter");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var TransactionErrorTypes_1 = require("../../../../common/enum/TransactionErrorTypes");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
exports.usePaymentEway = function () {
    var _a;
    var _b = client_1.useMutation(initPayment_1.default.INITIALIZE_PAYMENT), initPayment = _b[0], _c = _b[1], initPaymentData = _c.data, loading = _c.loading, initPaymentError = _c.error;
    var _d = react_1.useState(false), softLocked = _d[0], setSoftLocked = _d[1];
    var deal = useCheckoutContext_1.default().deal;
    var _e = usePlatformConfig_1.default().platformConfig.priceDisplay.primary, currency = _e.currency, subunitToUnit = _e.subunitToUnit, decimalScale = _e.decimalScale, currencyFormatConfig = _e.currencyFormatConfig;
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var priceFormatter = usePriceFormatter_1.default({
        currency: currency,
        dimensions: {
            country: dimensions.country,
            language: dimensions.language,
        },
        decimals: (decimalScale !== null && decimalScale !== void 0 ? decimalScale : 0),
        currencyFormatConfig: currencyFormatConfig,
    });
    var paymentAmount = react_1.useMemo(function () {
        var _a, _b, _c, _d;
        var orderFee = (_d = (_c = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.paymentFee) === null || _c === void 0 ? void 0 : _c.orderFee) === null || _d === void 0 ? void 0 : _d.find(function (orderFee) { return orderFee.currency === currency; });
        if (orderFee) {
            return priceFormatter.format(Number(orderFee.amount / (subunitToUnit || 1)));
        }
    }, [deal, currency]);
    var handleInitPayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var initData, e_1, softLockError;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, initPayment({
                            variables: {
                                identifier: deal.uuid,
                                paymentType: globalTypes_1.PaymentType.order_car,
                            },
                        })];
                case 1:
                    initData = _b.sent();
                    if (initData.data.initPayment.url) {
                        window.location.href = initData.data.initPayment.url;
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    softLockError = errorHandler_1.default.handleSoftLock(e_1);
                    setSoftLocked((_a = softLockError) === null || _a === void 0 ? void 0 : _a.isStockLocked);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var isPaymentFailed = ((_a = deal) === null || _a === void 0 ? void 0 : _a.status) === TransactionErrorTypes_1.TransactionErrorTypes.FAILED;
    return {
        handleInitPayment: handleInitPayment,
        initPaymentData: initPaymentData,
        loading: loading,
        initPaymentError: initPaymentError,
        paymentAmount: paymentAmount,
        isPaymentFailed: isPaymentFailed,
        softLocked: softLocked,
        setSoftLocked: setSoftLocked,
    };
};
